import axios from '../../utils/axios';
import { INTERNAL_SERVER_ERROR } from '../../constants/http';

const getSubcategoriesPerPage = async (page, limit, searchValue, supermarket, category) => {
  try {
    const { data } = await axios.get(`/api/subcategories?page=${page}&limit=${limit}&searchValue=${searchValue}&supermarket=${supermarket}&category=${category}`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const getSubcategoriesWithCategories = async (supermarket, category, subcategory) => {
  try {
    const { data } = await axios.get(`/api/subcategories/get/categories?supermarket=${supermarket}&category=${category}&subcategory=${subcategory}}`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const getAllSubcategories = async (supermarket, category, subcategory, scrape) => {
  try {
    const { data } = await axios.get(`/api/subcategories/get/all?supermarket=${supermarket}&category=${category}&subcategory=${subcategory}&scrape=${scrape}`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const updateSubcategoryFrequency = async (subcategoryId, frequency) => {
  try {
    const { data } = await axios.put(`/api/subcategories/${subcategoryId}?frequency=${frequency}`);

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const postCreateSubcategory = async (newData) => {
  try {
    const response = await axios.post('/api/subcategories/create', newData);
    return response.data;
  } catch (err) {
    return err.response.data;
  }
};

const getSubcategoryDetail = async (id) => {
  try {
    const { data } = await axios.get(`/api/subcategories/${id}`);

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const putEditSubcategory = async (newData) => {
  try {
    const { data } = await axios.put(`/api/subcategories/${newData.id}`, newData);

    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const deleteSubcategory = async (newData) => {
  try {
    const { data } = await axios.delete(`/api/subcategories/${newData.id}`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const getSubcategoriesObjetivesCount = async (startDate,
  endDate, supermarket, category, subcategory) => {
  try {
    const { data } = await axios.get(`/api/subcategoriesobjectives/count?startDate=${startDate}&endDate=${endDate}&supermarket=${supermarket}&category=${category}&subcategory=${subcategory}`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const getSubcategoriesObjetivesPagesCount = async (startDate,
  endDate, supermarket, category, subcategory) => {
  try {
    const { data } = await axios.get(`/api/subcategoriesobjectivespages/count?startDate=${startDate}&endDate=${endDate}&supermarket=${supermarket}&category=${category}&subcategory=${subcategory}`);
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const getSubcategoriesExport = async () => {
  try {
    const { data } = await axios.get('/api/subcategories/export');
    return {
      success: data.success,
      status: data.status,
      message: data.message,
      data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const getInactiveSubcategoriesPerPage = async (page, limit, searchValue, supermarket, category) => {
  try {
    const supermarketParam = Array.isArray(supermarket) ? supermarket.join(',') : (supermarket || '');
    const categoryParam = Array.isArray(category) ? category.join(',') : (category || '');
    const searchParam = searchValue || '';
    const response = await axios.get(`/api/subcategories/inactive?page=${page}&limit=${limit}&searchValue=${searchParam}&supermarket=${supermarketParam}&category=${categoryParam}`);

    // Manejar respuesta 204 (NO_CONTENT) - puede no tener body
    if (response.status === 204 || !response.data) {
      return {
        success: true,
        status: 204,
        message: 'No hay más subcategorías desactivadas.',
        data: {
          subcategories: [],
          totalSubcategories: 0,
        },
      };
    }

    return {
      success: response.data.success,
      status: response.data.status,
      message: response.data.message,
      data: response.data.data || response.data,
    };
  } catch (err) {
    // Si es 204, tratarlo como éxito sin resultados
    if (err.response && err.response.status === 204) {
      return {
        success: true,
        status: 204,
        message: 'No hay más subcategorías desactivadas.',
        data: {
          subcategories: [],
          totalSubcategories: 0,
        },
      };
    }

    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

const activateSubcategory = async (subcategoryId) => {
  try {
    const newDate = { id: subcategoryId, active: true };
    const response = await putEditSubcategory(newDate);
    return response;
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const message = err.response ? err.response.statusText : INTERNAL_SERVER_ERROR.message;
    return {
      success: false,
      status,
      message,
      data: {
        errorMessage: 'Ha ocurrido un error. Por favor intente nuevamente en unos minutos.',
      },
    };
  }
};

export {
  getSubcategoriesPerPage,
  getInactiveSubcategoriesPerPage,
  getSubcategoriesWithCategories,
  updateSubcategoryFrequency,
  postCreateSubcategory,
  getSubcategoryDetail,
  putEditSubcategory,
  deleteSubcategory,
  getAllSubcategories,
  getSubcategoriesObjetivesCount,
  getSubcategoriesObjetivesPagesCount,
  getSubcategoriesExport,
  activateSubcategory,
};
